<template>
  <div>
    <base-table
      :headers="headers"
      :items="table_matrix"
      disable-pagination
      hide-default-footer
      disable-sort
      height="100%"
      dense
      :loading="loading"
    >
      <template v-for="(h, i) in headers" v-slot:[`header.${h.value}`]="{ header }">
        <v-tooltip bottom :disabled="!h.tooltip" :key="i">
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ header.text }}</span>
          </template>
          <span>{{ header.tooltip }}</span>
        </v-tooltip>
      </template>
      <template #item="{ item }">
        <tr>
          <td
            v-for="(cell, i) in item"
            :key="i"
            :class="[tdHandleStyle(cell), `text-${cell.alignCell}`]"
            :colspan="colspanHandler(cell, i)"
            :style="displayHandler(cell, i)"
          >
            <!-- EMPTY CELL -->
            <template v-if="cell.dataActionLink && cell.dataActionLink.externalLink === null">
              <span></span>
            </template>
            <template v-else>
              <span v-if="!cell.dataActionLink">
                {{ cell.data }}
              </span>
              <span v-else>
                <a class="text-decoration-underline" @click="showModal(cell)">
                  {{ cell.data }}
                </a>
              </span>
            </template>
          </td>
        </tr>
      </template>
    </base-table>
  </div>
</template>
<script>
import BaseTable from '@/components/commons/BaseTable'
import Modal from './Modal'

export default {
  components: { BaseTable },
  props: {
    table: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
    },
    search: {
      type: [String, Number, Object, Boolean],
    },
  },
  computed: {
    headers() {
      return this.table?.header.map(item => {
        return {
          text: item.data,
          value: item.data,
          align: item.columnAlignment,
          tooltip: item?.tooltip
        }
      })
    },
    table_matrix() {
      //Inica matriz vacia
      let table_matrix = []

      //Por cada seccion en table
      this.table?.sections.forEach((section_element) => {
        //Arreglo Vacio de Seccion, contiene un objeto por fila
        let section = []

        //SubHeader
        //Se construye una fila con el valor SubHeader si existe
        if (section_element.subHeader) {
          let sub_header = section_element.subHeader.map((item, index) => {
            return [
              this.headers[index]?.text,
              {
                data: item ? item.data : item,
                dataUpper: item ? item.data?.toUpperCase() : item,
                dataType: item ? item.dataType : item,
                dataActionLink: item ? item.dataActionLink : item,
                rowType: 'subHeader',
                alignCell: this.headers[index]?.align
                  ? this.headers[index]?.align
                  : this.getRowAlign(item),
              },
            ]
          })
          section.push(Object.fromEntries(sub_header))
        }

        // Filas
        section_element.rows?.forEach((section_element) => {
          let tier = []
          section_element.row.map((item, index) => {
            tier.push([
              this.headers[index]?.text,
              {
                data: item && item.data !== null ? item.data : '-',
                dataUpper: item ? item.data?.toUpperCase() : item,
                dataType: item ? item.dataType : item,
                dataActionLink: item ? item.dataActionLink : item,
                rowType: 'row',
                alignCell: this.headers[index]?.align
                  ? this.headers[index]?.align
                  : this.getRowAlign(item),
              },
            ])
          })
          section.push(Object.fromEntries(tier))
        })

        //SubTotal
        //Se construye una fila con el valor SubTotal si este hubiere
        if (section_element.subTotal) {
          let sub_total = section_element.subTotal.map((item, index) => {
            return [
              this.headers[index]?.text,
              {
                data: item ? item.data : item,
                dataUpper: item ? item.data?.toUpperCase() : item,
                dataType: item ? item.dataType : item,
                dataActionLink: item ? item.dataActionLink : item,
                rowType: 'subTotal',
                alignCell: this.headers[index]?.align
                  ? this.headers[index]?.align
                  : this.getRowAlign(item),
              },
            ]
          })
          section.push(Object.fromEntries(sub_total))
        }

        //Se envia la seccion al arreglo bidimensional table_matrix
        table_matrix.push(section)
      })

      // Total
      // Se contruye una fila con el atributo total de la tabla si hubiera fila de total
      if (this.table.total) {
        let total = this.table.total.map((item, index) => {
          return [
            this.headers[index]?.text,
            {
              data: item ? item.data : '-',
              dataUpper: item ? item.data?.toUpperCase() : item,
              dataType: item ? item.dataType : item,
              dataActionLink: item ? item.dataActionLink : item,
              rowType: 'Total',
              alignCell: this.headers[index]?.align
                ? this.headers[index]?.align
                : this.getRowAlign(item),
            },
          ]
        })
        table_matrix.push(Object.fromEntries(total))
      }

      //Se retorna matriz llena
      // return table_matrix.flat()
      if (this.search && this.search.length > 0) {
        return table_matrix.flat().filter( item => {
          return this.headers[0]?.text && item[this.headers[0]?.text].dataUpper?.includes(this.search.toUpperCase()) ||
                this.headers[1]?.text && item[this.headers[1]?.text].dataUpper?.includes(this.search.toUpperCase()) ||
                this.headers[2]?.text && item[this.headers[2]?.text].dataUpper?.includes(this.search.toUpperCase()) ||
                this.headers[3]?.text && item[this.headers[3]?.text].dataUpper?.includes(this.search.toUpperCase()) ||
                this.headers[4]?.text && item[this.headers[4]?.text].dataUpper?.includes(this.search.toUpperCase()) ||
                this.headers[5]?.text && item[this.headers[5]?.text].dataUpper?.includes(this.search.toUpperCase()) ||
                this.headers[6]?.text && item[this.headers[6]?.text].dataUpper?.includes(this.search.toUpperCase()) ||
                this.headers[7]?.text && item[this.headers[7]?.text].dataUpper?.includes(this.search.toUpperCase()) ||
                this.headers[8]?.text && item[this.headers[8]?.text].dataUpper?.includes(this.search.toUpperCase()) ||
                this.headers[9]?.text && item[this.headers[9]?.text].dataUpper?.includes(this.search.toUpperCase()) ||
                this.headers[10]?.text && item[this.headers[10]?.text].dataUpper?.includes(this.search.toUpperCase()) ||
                this.headers[11]?.text && item[this.headers[11]?.text].dataUpper?.includes(this.search.toUpperCase())

        }).flat()
      } else {
        return table_matrix.flat()
      }
    },
  },
  methods: {
    tdHandleStyle(cell) {
      let styles = ''
      switch (cell.rowType) {
        case 'subHeader':
          styles = `font-weight-bold subHeader`
          break
        case 'subTotal':
          styles = `font-weight-bold subTotal`
          break
        case 'Total':
          styles = `font-weight-bold total`
      }
      return styles
    },
    async showModal(item) {
      if (
        item.dataActionLink?.externalLink &&
        item.dataActionLink.externalLink !== '-'
      ) {
        window.open(item.dataActionLink.externalLink, '_blank')
      } else if (item.dataActionLink?.endpoint) {
        const params = {
          fullscreen: this.$vuetify.breakpoint.smAndDown,
          width: '70%',
          transition: 'dialog-top-transition',
          item: item,
          showClose: false
        }

        await this.$dialog.showAndWait(Modal, params)
      }
    },
    getRowAlign(item) {
      return item?.dataType === 'number' ? 'right' : 'left'
    },
    colspanHandler(cell, i) {
      if (cell.rowType === 'subHeader' && this.headers[0]?.text === i) {
        return 3
      } else {
        return 1
      }
    },
    displayHandler(cell, i) {
      if (cell.rowType === 'subHeader' && this.headers[1]?.text === i) {
        return 'display: none;'
      }
      if (cell.rowType === 'subHeader' && this.headers[2]?.text === i) {
        return 'display: none;'
      }
    },
  },
  data() {
    return {
    }
  },
}
</script>
<style lang="sass" scoped>
.bt
  border-top: 1px solid black
.bb
  border-bottom: 1px solid black !important
.subHeader
  color: var(--v-primary-base)
  background-color: #FFFFFF !important
  border-top: 1px solid var(--v-primary-base)
  border-bottom: 1px solid var(--v-primary-base) !important
  text-transform: uppercase
.subTotal
  color: var(--v-primary-base)
  background-color: #FFFFFF !important
  border-top: 1px solid var(--v-primary-base)
  border-bottom: 1px solid var(--v-primary-base) !important
  text-transform: uppercase
.total
  background-color: var(--v-primary-base)
  color: #FFFF
  text-transform: uppercase
</style>
